'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$StoreSeed(secret) {
  this.N3 = null;
  this.N3 = secret;
}
export { $c_Lpresto_types$proto$StoreSeed as $c_Lpresto_types$proto$StoreSeed };
$p = $c_Lpresto_types$proto$StoreSeed.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$StoreSeed;
/** @constructor */
function $h_Lpresto_types$proto$StoreSeed() {
}
export { $h_Lpresto_types$proto$StoreSeed as $h_Lpresto_types$proto$StoreSeed };
$h_Lpresto_types$proto$StoreSeed.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$StoreSeed) && (this.N3 === x$0.N3)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "StoreSeed";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.N3;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$StoreSeed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.m2)));
}
export { $isArrayOf_Lpresto_types$proto$StoreSeed as $isArrayOf_Lpresto_types$proto$StoreSeed };
var $d_Lpresto_types$proto$StoreSeed = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$StoreSeed, "presto.types$proto$StoreSeed", ({
  m2: 1,
  m6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$StoreSeed as $d_Lpresto_types$proto$StoreSeed };
//# sourceMappingURL=presto.types$proto$-Store-Seed.js.map
